import { ChangeDetectorRef, Component, Injector, Input } from '@angular/core';
import { ApAlertService } from 'webcommon/core-ui';
import { FcListValidationService } from '../../generic/fc-list-validation/fc-list-validation.service';
import { ApFindControlService } from '../../ap-findcontrol.service';
import { FindControlInitDto, SystemGuid } from 'webcommon/shared';
import { ApFindControlBaseComponent } from '../../ap-findcontrol.base.component';
import { ApFindControlModalService } from '../../ap-findcontrol-modal.service';
import { ValidationErrors } from '@angular/forms';
import { FindControlIdService } from 'webcommon/legacy-common';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'fc-new-item-findcontrol-button',
  styleUrls: ['./fc-new-item-button.component.less'],
  templateUrl: './fc-new-item-button.component.html',
})
export class FcNewItemFindcontrolButtonComponent extends ApFindControlBaseComponent<string[]> {
  @Input() buttonTitle: string;

  public undoComponentId: number;
  public findControlInitDto: FindControlInitDto;


  constructor(
    apFindControlModalService: ApFindControlModalService,
    apFindControlService: ApFindControlService,
    findControlIdService: FindControlIdService,
    changeDetector: ChangeDetectorRef,
    elementInjector: Injector,
    systemGuid: SystemGuid,
  ) {
    super(apFindControlModalService, apFindControlService, findControlIdService, changeDetector, elementInjector, systemGuid);
  }

  protected createFormControlValueOrDefault(): string[] {
    return this.selectedPks ?? [];
  }

  protected matchesCurrentFormControlValue(data: string[]): boolean {
    return JSON.stringify(this.findControlFormControl?.value) === JSON.stringify(data);
  }

  public validate = (): ValidationErrors | null => {
    if (!this.chips.length) {
      if (this.isShowRequiredOnly()) { return null; }
    }
    const valid = this.getIsValid();
    return valid
      ? null
      : {
        required: true,
      };
  };

  protected getIsValid(): boolean {
    const isValid = !this.required || !!(this.chips.length);
    return isValid;
  }

  public onNewClick(): void {
    this.openModal();
  }
}
